import React from 'react';
import { useInView } from 'react-intersection-observer';
import { 
  FileCheck, Users, ClipboardCheck, 
  BarChart3, AlertCircle, CheckCircle 
} from 'lucide-react';

const steps = [
  {
    icon: FileCheck,
    title: 'Project Setup',
    description: 'Define scope, gather documentation, and set up your digital workspace.'
  },
  {
    icon: Users,
    title: 'Team Assembly',
    description: 'Invite stakeholders and assign roles with our collaborative platform.'
  },
  {
    icon: ClipboardCheck,
    title: 'Node Definition',
    description: 'Break down process systems into logical study nodes.'
  },
  {
    icon: BarChart3,
    title: 'Risk Analysis',
    description: 'Conduct systematic deviation analysis with our intelligent assistant.'
  },
  {
    icon: AlertCircle,
    title: 'Safeguard Review',
    description: 'Evaluate and document existing and recommended safeguards.'
  },
  {
    icon: CheckCircle,
    title: 'Report Generation',
    description: 'Auto-generate comprehensive reports and action items.'
  }
];

export default function Process() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section className="py-20 ">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">
            Our HAZOP Process
          </h2>
          <p className="text-xl text-black max-w-2xl mx-auto">
            A streamlined, digital approach to conducting HAZOP studies that ensures
            thoroughness and efficiency.
          </p>
        </div>

        <div 
          ref={ref}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div 
                key={index}
                className={`bg-white p-8 rounded-xl shadow-lg transform transition-all duration-700 hover:scale-105 ${
                  inView 
                    ? 'translate-y-0 opacity-100' 
                    : 'translate-y-20 opacity-0'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-900 rounded-xl flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3">
                  {step.title}
                </h3>
                <p className="text-black">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}